export enum KindResultDecisionCodesEnum {
  D_1 = 'D_1',
  D_2 = 'D_2',
  D_3 = 'D_3',
  D_4 = 'D_4',
  D_5 = 'D_5',
  D_6 = 'D_6',
  D_7 = 'D_7',
  D_8 = 'D_8',
  D_9 = 'D_9',
  D_10 = 'D_10',
}
